import { RouteName } from '@/constants/RouteName';
import { ChartTypes } from '@/types/ChartTypes';
import { PortfolioConstructionTabs } from '@/types/PortfolioConstructionTabs';
import type { AnalysisSubstep, AnalysisStep } from './AnalysisStep';

export const PORTFOLIO_CONSTRUCTION_PERFORMANCE: AnalysisSubstep = {
  title: 'Performance',
  graphTypes: [ChartTypes.TRACK_RECORD, ChartTypes.EXPOSURE],
  path: PortfolioConstructionTabs.SIMULATION,
  route: RouteName.PC_PERFORMANCE,
};
export const PORTFOLIO_CONSTRUCTION_EFFICIENT_FRONTIER: AnalysisSubstep = {
  title: 'Efficient Frontier',
  graphTypes: [ChartTypes.EFFICIENT_FRONTIER],
  path: PortfolioConstructionTabs.FRONTIER,
  route: RouteName.PC_EFFICIENT_FRONTIER,
};
export const PORTFOLIO_CONSTRUCTION_ROLLING: AnalysisSubstep = {
  title: 'Rolling Metrics',
  graphTypes: [ChartTypes.ROLLING_VOLATILITY, ChartTypes.ROLLING_SHARPE],
  path: PortfolioConstructionTabs.ROLLING,
  route: RouteName.PC_ROLLING,
};
export const PORTFOLIO_CONSTRUCTION_PERF_ATTRIB: AnalysisSubstep = {
  title: 'Contributions',
  graphTypes: [
    ChartTypes.PERFORMANCE_ATTRIBUTION_GROUP_BY,
    ChartTypes.CUMULATIVE_MONTHLY_RETURN_BREAKDOWN,
    ChartTypes.RANKING_TABLE,
  ],
  path: PortfolioConstructionTabs.PERFORMANCE_ATTRIBUTION,
  route: RouteName.PC_CONTRIBUTIONS,
};
export const PORTFOLIO_CONSTRUCTION_CORRELATION: AnalysisSubstep = {
  title: 'Correlation',
  graphTypes: [
    ChartTypes.ROLLING_CORRELATION,
    ChartTypes.CORRELATION,
    ChartTypes.RETURN_REGRESSION,
    ChartTypes.CORRELATION_MATRIX,
    ChartTypes.MST,
  ],
  path: PortfolioConstructionTabs.CORRELATION,
  route: RouteName.PC_CORRELATION,
};

export const PORTFOLIO_CONSTRUCTION_RECONCILIATION: AnalysisSubstep = {
  title: 'Reconciliation',
  graphTypes: [ChartTypes.CUMULATIVE_DRIFT, ChartTypes.RECONCILIATION_TABLE, ChartTypes.CUMULATIVE_PNL],
  path: PortfolioConstructionTabs.RECONCILIATION,
  route: RouteName.PC_RECONCILIATION,
};

export const PORTFOLIO_CONSTRUCTION_COMPOSITION: AnalysisSubstep = {
  title: 'Factor Composition',
  graphTypes: [ChartTypes.BARRA_GRAPH, ChartTypes.NOTIONAL_GRAPH, ChartTypes.BARRA_SPIDER_CHART],
  path: PortfolioConstructionTabs.COMPOSITION,
  route: RouteName.PC_COMPOSITION,
};

export const PORTFOLIO_CONSTRUCTION: AnalysisStep = {
  name: RouteName.PORTFOLIO_CONSTRUCTION,
  route: '/portfolio-construction',
  disabled: false,
  substeps: [
    PORTFOLIO_CONSTRUCTION_PERFORMANCE,
    PORTFOLIO_CONSTRUCTION_PERF_ATTRIB,
    PORTFOLIO_CONSTRUCTION_COMPOSITION,
    PORTFOLIO_CONSTRUCTION_EFFICIENT_FRONTIER,
    PORTFOLIO_CONSTRUCTION_ROLLING,
    PORTFOLIO_CONSTRUCTION_CORRELATION,
    PORTFOLIO_CONSTRUCTION_RECONCILIATION,
  ],
  icon: 'chart-line',
  mobileOnly: false,
  defaultSubstepPath: PORTFOLIO_CONSTRUCTION_PERFORMANCE.path,
};
